import {OrderCargoMods} from '~/types/types';
import {useOrderStore} from '~/stores/order';
import VzCargoMaxDimension from '~/components/personal/order/cargo/vz-cargo-max-dimension.vue';
import VzCargoPlaces from '~/components/personal/order/cargo/vz-cargo-places.vue';
import VzCargoParcels from '~/components/personal/order/cargo/vz-cargo-parcels.vue';
import VzCargoPallets from '~/components/personal/order/cargo/vz-cargo-pallets.vue';

const useCargoBlock = () => {
  const orderStore = useOrderStore()

  const tooltip = 'Груз не более 210 × 297 мм (А4), вес — не более 200 гр. Документы отправляются отдельным местом, упакованные в сейф-пакет'

  const mode = computed({
    get() {
      return orderStore.orderForm.cargo.mode
    },
    set(mode: OrderCargoMods) {
      orderStore.orderForm.cargo.mode = mode
      orderStore.getOrderPriceAction()
    }
  })

  const isTypeCargo = computed({
    get() {
      return orderStore.orderForm.cargo.type.cargo
    },
    set(val: boolean) {
      if (!val && !orderStore.orderForm.cargo.type.correspondence) {
        orderStore.orderForm.cargo.type.correspondence = true
      }
      orderStore.orderForm.cargo.type.cargo = val
      orderStore.getOrderPriceAction()
    }
  })

  const isTypeCorrespondence = computed({
    get() {
      return orderStore.orderForm.cargo.type.correspondence
    },
    set(val: boolean) {
      if (!val && !orderStore.orderForm.cargo.type.cargo) {
        orderStore.orderForm.cargo.type.cargo = true
      }
      orderStore.orderForm.cargo.type.correspondence = val
      orderStore.getOrderPriceAction()
    }
  })

  const orderLock = computed(() => {
    return Boolean(orderStore.orderForm?.meta?.lockState?.dispatch)
  })

  const isCloned = computed(() => {
    return !!useRoute().query.clone || false
  })

  const cargoModesComponent = computed(() => {
    switch (mode.value) {
      case 'dimension': {
        return VzCargoMaxDimension
      }
      case 'places': {
        return VzCargoPlaces
      }
      case 'parcels': {
        return VzCargoParcels
      }
      case 'pallets': {
        return VzCargoPallets
      }
    }
  })

  const isOnlyCorrespondence = computed(() => {
    return orderStore.orderForm.cargo.type.correspondence && !orderStore.orderForm.cargo.type.cargo
  })

  const isParcelsMode = computed(() => {
    return mode.value === 'parcels'
  })

  const disabled = computed(() => {
    return orderLock.value && !isCloned.value
  })

  return {
    mode,
    isTypeCargo,
    isTypeCorrespondence,
    orderLock,
    isCloned,
    tooltip,
    cargoModesComponent,
    isOnlyCorrespondence,
    isParcelsMode,
    disabled
  }
}

export default useCargoBlock
